module.exports = __webpack_public_path__ + "img/credential-6.4650fbca.png";